import { MapSchema, Schema, type } from "@colyseus/schema"
import { CardDataClass } from "./сard"

export type CardsRange = 0 | 1 | 2 | 3 | 4 | 5

export class CardsOnTableClass extends Schema {
  @type({ map: CardDataClass })
  defendingCards = new MapSchema<CardDataClass>()

  @type({ map: CardDataClass })
  attackingCards = new MapSchema<CardDataClass>()

  constructor() {
    super()

    this.defendingCards = new MapSchema<CardDataClass>()
    this.attackingCards = new MapSchema<CardDataClass>()
  }

  pushToAttackingCards(card: CardDataClass): string {
    const nextKey = this.attackingCards.size.toString()

    this.attackingCards.set(nextKey, card)

    return nextKey
  }
}

export type CardsOnTable = InstanceType<typeof CardsOnTableClass>
